const getLgBasisClass = (itemsCount: number) => {
  const basisMap: Record<number, string> = {
    1: 'lg:basis-full',
    2: 'lg:basis-1/2',
    3: 'lg:basis-1/3',
    4: 'lg:basis-1/4',
    5: 'lg:basis-1/5',
    6: 'lg:basis-1/6',
  };
  return basisMap[itemsCount] || `lg:basis-1/${itemsCount}`;
};

export const getCarouselItemClass = (index: number, itemsCount: number) => {
  const lgBasis = getLgBasisClass(itemsCount);
  if (index === 0) return `ml-12 mr-2 lg:ml-0 basis-9/12 ${lgBasis}`;
  if (index === itemsCount - 1) return `mr-12 ml-2 lg:mr-0 basis-9/12 ${lgBasis}`;
  return `ml-2 mr-2 lg:mx-0 basis-9/12 ${lgBasis}`;
};

export const getTabSliderClass = (index: number, itemsCount: number) => {
  if (index === 0) return 'ml-20';
  if (index === itemsCount - 1) return 'mr-20';
  return 'mx-0';
};
